module.exports = __webpack_public_path__ + "img/icon-tri-1.e66dba36.svg";